<script>
    import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

    export default {
        name: 'design-2021-analytics-index-component',
        components: { Design2021ApprenticeDataTable },
        props: {
            schoolsIn: {
                type: Array
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true
                    },
                    {
                        key: 'groups_count',
                        label: this.$t('analytics.group_count'),
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: this.$t('common.actions')
                    }
                ]
            };
        },
        methods: {
            selectSchool(school) {
                window.location.href = this.routes.adminAnalyticsSchool(school.id);
            }
        }
    };
</script>

<template>
    <div class="apprentice-simple-card">
        <design2021-apprentice-data-table
            :items="schoolsIn"
            :fields="fields"
        >
            <template #cell(actions)="data">
                <div class="row-actions">
                    <b-button
                        class="btn-open"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('analytics.add_tags')"
                        @click="selectSchool(data.item)">
                    </b-button>
                </div>
            </template>
        </design2021-apprentice-data-table>
    </div>
</template>

<style scoped lang="scss">

</style>